import {createNamespacedHelpers} from 'vuex'
let {mapMutations} = createNamespacedHelpers('technical')

const setPreloader = {
    methods: {
        ...mapMutations(['SET_INVISIBLE_PRELOADER', 'SET_VISIBLE_PRELOADER']),
        openPrealoder() {
            this.SET_VISIBLE_PRELOADER()
        },
        closePreloader() {
            this.SET_INVISIBLE_PRELOADER()
        }
    }
}
export default setPreloader
